import checkIcon from "@icons/check.svg";
import Cookies from "js-cookie";
import { slideDown, slideToggle, slideUp } from "./dom-manipulation/animation";

const misc = {
    /**
     * Load more blog posts via AJAX and append them to the page.
     *
     * @returns {void}
     */
    showMore() {
        const button = document.querySelector(".btn-see-more-blogposts");
        const nextPageUrl =
            button instanceof HTMLElement ? button.dataset.url : undefined;
        const wrapper = document.querySelector(".blog-posts-wrapper");

        if (!nextPageUrl || !wrapper) return;

        wrapper.insertAdjacentHTML(
            "beforeend",
            '<div class="logo-loader"><div class="logo-spinner"></div></div>',
        );
        wrapper.classList.add("loading");

        fetch(nextPageUrl)
            .then((response) => response.json())
            .then((data) => {
                document.querySelector(".btn-wrapper")?.remove();
                document.querySelector(".logo-loader")?.remove();
                wrapper.insertAdjacentHTML("beforeend", data);
                wrapper.classList.remove("loading");
            });
    },
    /**
     * Set a cookie that expires at a given hour the next day.
     *
     * @param {string} name - The cookie name.
     * @param {string} value - The cookie value.
     * @param {number} time - The hour (0-23) at which the cookie should expire the next day.
     * @returns {void}
     */
    setCookieWithExpiryNextDay(name, value, time) {
        let now = new Date();
        let expiresTime = new Date();
        let timeZoneOffset = now.getTimezoneOffset() * 60 * 1000;

        // TODO: `setHours` already works in local time, so subtracting the offset
        // double-corrects and moves the expiry off the requested hour by the visitor's
        // offset — a customer in UTC+2 asking for 04:00 gets 06:00 local. Dropping the
        // `timeZoneOffset` subtraction is the fix; keep it if the intent was actually a
        // fixed UTC hour, in which case use `setUTCHours` and say so.
        // tests/js/webshop/helpers/misc.test.js pins the current behaviour.
        expiresTime.setDate(now.getDate() + 1);
        expiresTime.setHours(time, 0, 0, 0);
        expiresTime = new Date(expiresTime.getTime() - timeZoneOffset);

        Cookies.set(name, value, { expires: expiresTime, path: "/" });
    },
    /**
     * Copy text content of an element to the clipboard and temporarily swap button text.
     *
     * @param {string} selector - CSS selector for the element whose text to copy.
     * @param {string} id - The ID of the button element.
     * @param {string} replacementElement - HTML to show in the button while the copy confirmation is visible.
     * @returns {void}
     */
    copyToClipboard(selector, id, replacementElement) {
        const element = document.querySelector(selector);
        const button = document.getElementById(id);

        if (
            element &&
            button &&
            navigator?.clipboard?.writeText &&
            window.isSecureContext
        ) {
            const originalText = button.innerText;
            navigator.clipboard.writeText(
                /** @type {HTMLElement} */ (element).innerText,
            );
            const buttonWidth = button.offsetWidth;
            button.style.minWidth = `${buttonWidth}px`;
            button.innerHTML = replacementElement;

            setTimeout(() => {
                button.innerText = originalText;
            }, 2500);
        }
    },
    slideUp,
    slideDown,
    slideToggle,
};

window.misc = misc;

const COPY_TO_CLIPBOARD_CHECKMARK = `<img src='${checkIcon}' class='svg-filter-white' style='height: 12px;'>`;

document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const trigger = target.closest("[data-copy-to-clipboard]");

    if (!(trigger instanceof HTMLElement)) return;

    misc.copyToClipboard(
        `#${trigger.dataset.copyToClipboard}`,
        trigger.id,
        COPY_TO_CLIPBOARD_CHECKMARK,
    );
});
